var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcSmiley(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 28C22.6274 28 28 22.6274 28 16C28 9.37258 22.6274 4 16 4C9.37258 4 4 9.37258 4 16C4 22.6274 9.37258 28 16 28Z",
    stroke: "#444F60",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5 14.75C12.1904 14.75 12.75 14.1904 12.75 13.5C12.75 12.8096 12.1904 12.25 11.5 12.25C10.8096 12.25 10.25 12.8096 10.25 13.5C10.25 14.1904 10.8096 14.75 11.5 14.75Z",
    fill: "#444F60"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5 14.75C21.1904 14.75 21.75 14.1904 21.75 13.5C21.75 12.8096 21.1904 12.25 20.5 12.25C19.8096 12.25 19.25 12.8096 19.25 13.5C19.25 14.1904 19.8096 14.75 20.5 14.75Z",
    fill: "#444F60"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M21.2 19C20.6714 19.9107 19.9128 20.6667 19.0002 21.1922C18.0876 21.7176 17.053 21.9942 16 21.9942C14.9469 21.9942 13.9123 21.7176 12.9998 21.1922C12.0872 20.6667 11.3286 19.9107 10.8 19",
    stroke: "#444F60",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcSmiley);
export default __webpack_public_path__ + "static/media/ic_smiley.f966e518d30fbfc0c63cba52669aff84.svg";
export { ForwardRef as ReactComponent };